import { render, staticRenderFns } from "./AssignValidationRequest.vue?vue&type=template&id=70bd9c88&scoped=true"
import script from "./AssignValidationRequest.vue?vue&type=script&lang=js"
export * from "./AssignValidationRequest.vue?vue&type=script&lang=js"
import style0 from "./AssignValidationRequest.vue?vue&type=style&index=0&id=70bd9c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd9c88",
  null
  
)

export default component.exports